import React, { useState, useEffect, Fragment } from 'react';
import { API, Storage } from 'aws-amplify';
import { createEvent as createEventMut, deleteEvent as deleteEventMut, updateEvent as updateEventMut } from '../graphql/mutations';
import { sports } from '../enum/sports';
import { states } from '../enum/states';
import { fetchEvents } from '../api/api'
import { AmplifyAuthenticator, AmplifySignOut, AmplifySignIn } from '@aws-amplify/ui-react';
import { onAuthUIStateChange } from '@aws-amplify/ui-components';


import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';

import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const initialFormState = {
    id: null,
    name: '',
    athleteName: '',
    registrationOpen: '1/1/2021',
    registrationClose: '1/1/2021',
    startDate: '1/1/2021',
    endDate: '1/1/2021',
    startTime: '08:00',
    endTime: '16:00',
    addressOne: '',
    addressTwo: '',
    city: '',
    zip: '',
    state: '',
    cost: '',
    refundPolicy: '',
    contact: '',
    description: '',
    bannerImage: '',
    athleteImage: '',
    sport: '',
    slug: '',
    registrationURL: ''
}

//material ui-theme - move to central location
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        backgroundColor: 'white'
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        backgroundColor: 'white'
    },
    datePicker: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        backgroundColor: 'white'
    },
}));

function Admin() {
    const [authState, setAuthState] = useState([]);
    const [events, setEvents] = useState([]);
    const [formData, setFormData] = useState(initialFormState);
    const classes = useStyles();

    useEffect(() => {
        (async () => {
            setEvents(await fetchEvents({loadImageFilenameOnly: true}));
        })();
    }, []);

    useEffect(() => {
        return onAuthUIStateChange((nextAuthState, authData) => {
            setAuthState(nextAuthState);
            //setUser(authData)
        });
    }, []);


    const handleAuthStateChange = (state) => {
        setAuthState(state);
    }

    //TODO: Create single onChange function for both image inputs
    async function onChangeBannerImageInput(e) {
        if (!e.target.files[0]) return
        const file = e.target.files[0];
        setFormData({ ...formData, bannerImage: file.name });
        await Storage.put(file.name, file);
        fetchEvents({loadImageFilenameOnly: true});
    }

    async function onChangeAthleteImageInput(e) {
        if (!e.target.files[0]) return
        const file = e.target.files[0];
        setFormData({ ...formData, athleteImage: file.name });
        await Storage.put(file.name, file);
        fetchEvents({loadImageFilenameOnly: true});
    }

    //create new event
    async function createEvent() {
        if (!formData.name) return; //check for required fields

        await API.graphql({ query: createEventMut, variables: { input: formData } }); //API call - add new event

        //check for banner image & upload
        if (formData.bannerImage) {
            const bannerImage = await Storage.get(formData.bannerImage);
            formData.bannerImage = bannerImage;
        }

        //check for athlete image & upload
        if (formData.athleteImage) {
            const athleteImage = await Storage.get(formData.athleteImage);
            formData.athleteImage = athleteImage;
        }

        setEvents([...events, formData]); //add new event
        setFormData(initialFormState); //reset form data
    }

    //create new event
    const resetForm = () => {
        setFormData(initialFormState); //reset form data
    }

    //create new event
    async function updateEvent() {
        console.log(formData);
        if (!formData.name) return; //check for required fields
        console.log(formData.bannerImage);
        await API.graphql({ query: updateEventMut, variables: { input: formData } }); //API call - add new event

        //setEvents([...events, formData]); //add new event
        setFormData(initialFormState); //reset form data
    }

    //delete event
    async function deleteEvent({ id }) {
        const newEventsArray = events.filter(event => event.id !== id);
        setEvents(newEventsArray);
        await API.graphql({ query: deleteEventMut, variables: { input: { id } } });
    }

    //delete event
    function updateFormEvent(event) {
        delete event.createdAt;
        delete event.updatedAt;
        console.log(event);
        setFormData(event)
    }

    return (

        <div className="admin">
            {authState !== 'signedin'
                ?
                <Fragment>
                    <AmplifyAuthenticator hideDefault={true}>
                        <AmplifySignIn
                            handleAuthStateChange={handleAuthStateChange}
                            headerText="Admin Portal Sign-In"
                            slot="sign-in"
                            hideSignUp={true}
                        ></AmplifySignIn>
                    </AmplifyAuthenticator>
                </Fragment>
                :
                <Fragment>
                    <h1>Manage Events</h1>
                    <div className="row justify-content-center p-5">
                        <form name="event_creation_form" id='event_creation_form'>
                            <input hidden readOnly value={formData.id}></input>
                            <Grid container justifyContent="space-around">
                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >Event Name</InputLabel>
                                        <TextField
                                            placeholder="Event Name"
                                            value={formData.name}
                                            onChange={e => setFormData({ ...formData, 'name': e.target.value })}
                                            variant="outlined"
                                            className={classes.textField}
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >Athlete Name</InputLabel>
                                        <TextField
                                            placeholder="Athlete Name"
                                            value={formData.athleteName}
                                            onChange={e => setFormData({ ...formData, 'athleteName': e.target.value })}
                                            variant="outlined"
                                            className={classes.textField}
                                        />
                                    </FormControl>
                                </Grid>

                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                                        <KeyboardDatePicker
                                            className={classes.datePicker}
                                            disableToolbar
                                            variant="inline"
                                            inputVariant="outlined"
                                            format="MM/dd/yyyy"
                                            margin="normal"
                                            id="date-picker-inline"
                                            label="Start Date"
                                            value={formData.startDate}
                                            onChange={e => setFormData({ ...formData, 'startDate': (e.getMonth() + 1) + '/' + e.getDate() + '/' + e.getFullYear() })}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                                        <KeyboardDatePicker
                                            className={classes.datePicker}
                                            disableToolbar
                                            variant="inline"
                                            format="MM/dd/yyyy"
                                            inputVariant="outlined"
                                            margin="normal"
                                            id="date-picker-inline"
                                            label="End Date"
                                            value={formData.endDate}
                                            onChange={e => setFormData({ ...formData, 'endDate': (e.getMonth() + 1) + '/' + e.getDate() + '/' + e.getFullYear() })}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >Start Time</InputLabel>
                                        <TextField
                                            className={classes.textField}
                                            type="time"
                                            value={formData.startTime}
                                            onChange={e => setFormData({ ...formData, 'startTime': e.target.value })}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            inputProps={{
                                                step: 300, // 5 min
                                            }}
                                        />
                                    </FormControl>
                                    </Grid>
                                    <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >End Time</InputLabel>
                                        <TextField
                                            className={classes.textField}
                                            type="time"
                                            value={formData.endTime}
                                            onChange={e => setFormData({ ...formData, 'endTime': e.target.value })}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            inputProps={{
                                                step: 300, // 5 min
                                            }}
                                        />
                                    </FormControl>
                                    </Grid>
                                    <br /><br />
                                    <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                                        <KeyboardDatePicker
                                            className={classes.datePicker}
                                            disableToolbar
                                            variant="inline"
                                            format="MM/dd/yyyy"
                                            inputVariant="outlined"
                                            margin="normal"
                                            id="date-picker-inline"
                                            label="Registration Open Date"
                                            value={formData.registrationOpen}
                                            onChange={e => setFormData({ ...formData, 'registrationOpen': (e.getMonth() + 1) + '/' + e.getDate() + '/' + e.getFullYear() })}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                                        <KeyboardDatePicker
                                            className={classes.datePicker}
                                            disableToolbar
                                            variant="inline"
                                            format="MM/dd/yyyy"
                                            inputVariant="outlined"
                                            margin="normal"
                                            id="date-picker-inline"
                                            label="Registration Close Date"
                                            value={formData.registrationClose}
                                            onChange={e => setFormData({ ...formData, 'registrationClose': (e.getMonth() + 1) + '/' + e.getDate() + '/' + e.getFullYear() })}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                        </Grid>
                                </MuiPickersUtilsProvider>

                                <br /><br />
                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >Address Line 1</InputLabel>
                                        <TextField
                                            placeholder="Kids Camp Building"
                                            value={formData.addressOne}
                                            onChange={e => setFormData({ ...formData, 'addressOne': e.target.value })}
                                            variant="outlined"
                                            className={classes.textField}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >Address Line 2</InputLabel>
                                        <TextField
                                            placeholder="100 Event Blvd"
                                            value={formData.addressTwo}
                                            onChange={e => setFormData({ ...formData, 'addressTwo': e.target.value })}
                                            variant="outlined"
                                            className={classes.textField}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >City</InputLabel>
                                        <TextField
                                            placeholder="Funtown"
                                            value={formData.city}
                                            onChange={e => setFormData({ ...formData, 'city': e.target.value })}
                                            variant="outlined"
                                            className={classes.textField}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >State</InputLabel>
                                        <Select
                                            value={formData.state}
                                            onChange={e => setFormData({ ...formData, 'state': e.target.value })}
                                            className={classes.selectEmpty}

                                        >
                                            <MenuItem value=""><em>Select State</em></MenuItem>
                                            {Object.keys(states).map(key => (
                                                <MenuItem value={key}>{states[key].name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >Zip</InputLabel>
                                        <TextField
                                            placeholder="90213"
                                            value={formData.zip}
                                            onChange={e => setFormData({ ...formData, 'zip': e.target.value })}
                                            variant="outlined"
                                            className={classes.textField}
                                        />
                                    </FormControl>
                                </Grid>
                                <br /> <br />
                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >Cost</InputLabel>
                                        <TextField
                                            placeholder="Cost"
                                            value={formData.cost}
                                            onChange={e => setFormData({ ...formData, 'cost': e.target.value })}
                                            variant="outlined"
                                            className={classes.textField}
                                        />
                                    </FormControl>

                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >Refund Policy</InputLabel>
                                        <TextField
                                            onChange={e => setFormData({ ...formData, 'refundPolicy': e.target.value })}
                                            value={formData.refundPolicy}
                                            variant="outlined"
                                            className={classes.textField}
                                            placeholder="The refund policy for our camp..."
                                            multiline
                                            rows={5}
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >Contact Info</InputLabel>
                                        <TextField
                                            onChange={e => setFormData({ ...formData, 'contact': e.target.value })}
                                            value={formData.contact}
                                            variant="outlined"
                                            className={classes.textField}
                                            placeholder="You can contact us at..."
                                            multiline
                                            rows={5}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >Description</InputLabel>
                                        <TextField
                                            onChange={e => setFormData({ ...formData, 'description': e.target.value })}
                                            value={formData.description}
                                            variant="outlined"
                                            className={classes.textField}
                                            placeholder="Our camp will help kids learn..."
                                            multiline
                                            rows={10}
                                        />
                                    </FormControl>

                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >Page URL (slug)</InputLabel>
                                        <TextField
                                            placeholder="athlete-name"
                                            value={formData.slug}
                                            onChange={e => setFormData({ ...formData, 'slug': e.target.value })}
                                            variant="outlined"
                                            className={classes.textField}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >Registration URL</InputLabel>
                                        <TextField
                                            placeholder="https://registrations.kjkregistrations.com/#/register/event/"
                                            value={formData.registrationURL}
                                            onChange={e => setFormData({ ...formData, 'registrationURL': e.target.value })}
                                            variant="outlined"
                                            className={classes.textField}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >Sport</InputLabel>
                                        <Select
                                            value={formData.sport}
                                            onChange={e => setFormData({ ...formData, 'sport': e.target.value })}
                                            className={classes.selectEmpty}

                                        >
                                            <MenuItem value=""><em>Any</em></MenuItem>
                                            {Object.keys(sports).map(key => (
                                                <MenuItem value={key}>{sports[key].name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <br /><br />
                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >Select Banner Image</InputLabel>
                                        <Button
                                            className={classes.selectEmpty}
                                            variant="outlined"
                                            component="label"
                                        >
                                            {formData.bannerImage === '' ? 'Upload Banner' : 'Banner Selected'}
                                            <input
                                                onChange={onChangeBannerImageInput}
                                                type="file"
                                                hidden
                                            />
                                        </Button>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                        <InputLabel shrink >Select Athlete Image</InputLabel>
                                        <Button
                                            className={classes.selectEmpty}
                                            variant="outlined"
                                            component="label"
                                        >
                                            {formData.athleteImage === '' ? 'Upload Athlete Image' : 'Athlete Image Selected'}
                                            <input
                                                onChange={onChangeAthleteImageInput}
                                                type="file"
                                                hidden
                                            />
                                        </Button>
                                    </FormControl>
                                </Grid>
                                <button onClick={resetForm} className="btn mx-auto  mt-4 mb-4 btn-secondary d-flex" >
                                    <div className="btn-text p-2  justify-content-center align-self-center mx-auto">{formData.id ? 'DISCARD CHANGES' : 'RESET FORM'}</div>
                                </button>
                                <button onClick={!formData.id ? createEvent : updateEvent} className="btn mx-auto  mt-4 mb-4 btn-primary d-flex" >
                                    <div className="btn-text p-2  justify-content-center align-self-center mx-auto">{!formData.id ? 'CREATE EVENT' : 'UPDATE EVENT'}</div>
                                </button>

                            </Grid>
                        </form>
                    </div>
                    <div>
                        <table className="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>Event Name</th>
                                    <th>Athlete</th>
                                    <th>Registration Start</th>
                                    <th>Registration End</th>
                                    <th>Start date</th>
                                    <th>Sport</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    events.map(event => (
                                        <tr key={event.id || event.name}>
                                            <td>{event.name}</td>
                                            <td>{event.athleteName}</td>
                                            <td>{event.registrationOpen}</td>
                                            <td>{event.registrationClose}</td>
                                            <td>{event.startDate}</td>
                                            <td>{event.sport}</td>
                                            <td>
                                                <button onClick={() => deleteEvent(event)}>Delete Event</button>
                                                <button onClick={() => updateFormEvent(event)}>Update Event</button>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                    <AmplifySignOut handleAuthStateChange={handleAuthStateChange} />
                </Fragment>
            }

        </div>
    );
}

export default Admin;




